export default __webpack_public_path__ + "static/media/2BRZ.2315d9c0.svg";